<template>
    <b-modal
        title-tag="h2"
        title="Merge Item"
        :lazy="true"
        :visible="isOpen"
        no-close-on-backdrop
        no-close-on-esc
    >
        <b-alert variant="warning" show>
            Warning: The merge action you are requesting is IRREVERSIBLE.
            <br />
            Once an item is merged into another item, the merge cannot be
            undone. Do you want to merge these items?
        </b-alert>

        <b-form-group label-cols="3" label="Item:" label-for="item">
            <b-form-input plaintext :value="name"></b-form-input>
        </b-form-group>

        <b-form-group label-cols="3" label="Merge Into:" label-for="merge">
            <vet-select
                module="item"
                placeholder="Item (required)"
                v-validate="'required'"
                name="mergeinto"
                label="display_name"
                v-model="mergeIntoItem"
                :show-menu="false"
                :class="{ 'border-danger': errors.has('mergeinto') }"
                :excluded-id="sourceitemId"
                :selectProps="vetItemProps"
                :isMergeItem="true"
            />
        </b-form-group>

        <b-form-group label-cols="3" label="Notes:" label-for="notes">
            <b-form-textarea
                v-model="notes"
                placeholder="Notes (optional)"
                rows="5"
            />
        </b-form-group>

        <merge-confirmation
            ref="confirmationText"
            module="item"
            class="pt-1"
            :item-first="name"
            :item-second="mergeIntoItemName"
            @is-matched="isMatched => (isConfirmationTextMatch = isMatched)"
        />

        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isLoading"
                variant="primary"
                @click="proceed"
                :disabled="!enableMergeButton"
            >
                Continue to Merge
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import ItemService from "@/services/items";
import MergeConfirmation from "@/module/commons/merge-confirmation";
import Loader from "@/module/commons/loader";
import VetSelect from "@/module/commons/vet-select";

export default {
    components: {
        Loader,
        VetSelect,
        MergeConfirmation
    },
    data() {
        return {
            sourceitemId: null,
            name: "",
            isOpen: false,
            isLoading: false,
            mergeIntoItem: null,
            notes: "",
            search: "",
            vetItemProps: {
                id: "",
                item_type: "",
                module: "",
                status: "",
                start: "",
                image_source: ""
            },
            isConfirmationTextMatch: false
        };
    },
    computed: {
        mergeIntoItemName() {
            return this.mergeIntoItem ? this.mergeIntoItem.display_name : null;
        },
        enableMergeButton() {
            return this.isConfirmationTextMatch;
        }
    },
    methods: {
        open({ itemId, itemName }) {
            this.isOpen = true;
            this.sourceitemId = itemId;
            this.name = itemName;
        },
        close() {
            this.isOpen = false;
        },
        async proceed() {
            const valid = await this.$validator.validateAll();
            const isConfirmationValid = this.$refs.confirmationText.isValid();

            if (!valid || !isConfirmationValid) {
                return false;
            }

            try {
                this.isLoading = true;
                // validate if source id === target id
                if (this.sourceitemId === this.mergeIntoItem.id) {
                    throw new Error("Error: Cannot merge the same item.");
                }

                const targetteditemId = this.mergeIntoItem.id;

                let formData = new FormData();
                formData.append("previous_item_id", this.sourceitemId);
                formData.append("current_item_id", targetteditemId);
                formData.append("notes", this.notes);
                const res = await ItemService.mergeItem(formData);
                if (res) {
                    this.isLoading = false;
                    this._message("Item merged successfully");
                    this.close();
                    this.$emit("onsuccess", res.current_item.encoded_id);
                } else {
                    throw new Error("Error: Cannot merge item");
                }
            } catch (error) {
                this.isLoading = false;
                this._message(error.message, "danger");
            }
        }
    }
};
</script>
